import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { RoleEnum } from "@classview/shared-types";

import { SelectThumbnailFrame } from "./select-thumbnail-frame";
import { UploadCustomThumbnail } from "./upload-custom-thumbnail";

type ModifyThumbnailModalProps = {
  videoURL: string;
  recordingId: string;
  handleModalClose: () => void;
};

export function ModifyThumbnailModal({
  videoURL,
  recordingId,
  handleModalClose,
}: ModifyThumbnailModalProps) {
  const { hasPermission } = useOrganisation();

  const canUploadCustomThumbnail = hasPermission(RoleEnum.REPLAY_ADVANCED);

  return (
    <>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>Modify thumbnail</DialogTitle>
        </DialogHeader>

        <Tabs defaultValue="select-frame">
          <TabsList>
            <TabsTrigger value="select-frame">Select Frame</TabsTrigger>
            {canUploadCustomThumbnail && (
              <TabsTrigger value="upload-custom">Upload Custom</TabsTrigger>
            )}
          </TabsList>
          <TabsContent value="select-frame">
            <SelectThumbnailFrame
              videoURL={videoURL}
              recordingId={recordingId}
              handleModalClose={handleModalClose}
            />
          </TabsContent>
          {canUploadCustomThumbnail && (
            <TabsContent value="upload-custom">
              <UploadCustomThumbnail recordingId={recordingId} />
            </TabsContent>
          )}
        </Tabs>
      </DialogContent>
    </>
  );
}
